import i18n from '@/helper/i18n';
/**
 * @param {String} code
 * @param {'customer' | 'business'} type
 */
export const formatSolvencyReasonCode = (code, type) =>
  i18n.te(`debtors.solvencyReasonCodes.${type}.${code}`)
    ? i18n.t(`debtors.solvencyReasonCodes.${type}.${code}`)
    : '';
